import { Pipe, PipeTransform } from '@angular/core';
import { BoneTypeEnum, LanguageService } from '../../core';


/**
 * Pipe to convert Bone Type enum to display value.
 */
@Pipe({
	name: 'boneTypeLabel'
})
export class BoneTypeLabelPipe implements PipeTransform {

	constructor(private readonly langSrv: LanguageService) { }

	transform(boneType: BoneTypeEnum): string {
		return boneTypeTranslate(boneType, this.langSrv.labels());
	}

}


export const boneTypeTranslate = (boneType: BoneTypeEnum, labels: any): string => {
	switch (boneType) {
		case BoneTypeEnum.LongLeg: return labels.BONE_TYPE_LONG_LEG_LABEL;
		case BoneTypeEnum.Femur: return labels.BONE_TYPE_FEMUR_LABEL;
		case BoneTypeEnum.Tibia: return labels.BONE_TYPE_TIBIA_LABEL;
		case BoneTypeEnum.Ankle: return labels.BONE_TYPE_ANKLE_LABEL;
		case BoneTypeEnum.Forefoot: return labels.BONE_TYPE_FOREFOOT_LABEL;
		case BoneTypeEnum.Hindfoot: return labels.BONE_TYPE_HINDFOOT_LABEL;
		default: return boneType;
	}
}
